import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import BlockRoundIcon from "@rsuite/icons/BlockRound";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import React, { useRef, useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewProfileModal from "./ViewProfile";
import AddAddressModal from "./AddAddress";
import ViewAddressModal from "./ViewAddress";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";

const UserSingleAction = ({
  userData,
  onDeleteUser,
  onPublishUser,
  permission,
  dataPermission,
  ...props
}: {
  userData: any;
  onDeleteUser: Function;
  onPublishUser: Function;
  permission: any;
  dataPermission: Function;
}) => {
  const { t } = useTranslation();
  const userRef = useRef({});
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [isEditAddress, setIsEditAddress] = useState(false);
  const [isAddressChanged, setIsAddressChanged] = useState(false);
  const [editAddObj, setEditAddObj] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedUserId = encryptUrl(`${userData.id}`);

  const userUpdateLink = ContentRoutes.UPDATE_USER.replace(
    ":id",
    ecryptedUserId.toString()
  );
  const navigate = useNavigate();
  const publishText =
    userData.status == statusArr.active
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t("CONFIRM_ACTION", {
    action:
      userData.status == statusArr.active
        ? t("UNPUBLISH").toLowerCase()
        : t("PUBLISH").toLowerCase(),
    entity: t("USER").toLowerCase(),
  });
  const publishIcon =
    userData.status == statusArr.inactive ? (
      <BlockRoundIcon />
    ) : (
      <CheckRoundIcon />
    );

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      setOpenModalByName(eventKey);
      dispatch(setActionData(userData));
      onClose();
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-profile"}>{t("VIEW")}</Dropdown.Item>
          <Dropdown.Item eventKey={"view-address"}>
            {t("VIEW")} {t("ADDRESS")}
          </Dropdown.Item>
          <Dropdown.Item eventKey={"add-address"}>
            {" "}
            {t("ADD")} {t("ADDRESS")}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${userUpdateLink}`);
  }
  return (
    <div>
      {permission.update && dataPermission(userData) && (
        <>
          <IconButton
            appearance="subtle"
            onClick={handleEditAction}
            title={t("EDIT")}
            icon={<Edit />}
          />
        </>
      )}
      {permission.delete && dataPermission(userData) && (
        <>
          <IconButton
            onClick={() => {
              userRef.current = userData;
              setOpenDeleteModal(true);
            }}
            icon={<Trash />}
            title={t("DELETE")}
            size="md"
          />
        </>
      )}
      {permission.publish && dataPermission(userData) && (
        <>
          <IconButton
            onClick={() => {
              userRef.current = userData;
              setOpenPublishModal(true);
              setPublishMessage(pMessage);
            }}
            icon={publishIcon}
            title={publishText}
            size="md"
          />
        </>
      )}
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-profile" && (
        <ViewProfileModal
          status={openModalByName === "view-profile" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      {openModalByName === "add-address" && (
        <AddAddressModal
          status={openModalByName === "add-address" ? true : false}
          toggle={setOpenModalByName}
          isEditAddress={isEditAddress}
          editAddObj={editAddObj}
          setIsAddressChanged={setIsAddressChanged}
          setIsEditAddress={setIsEditAddress}
          setEditAddObj={setEditAddObj}
        />
      )}
      {openModalByName === "view-address" && (
        <ViewAddressModal
          status={openModalByName === "view-address" ? true : false}
          toggle={setOpenModalByName}
          setIsEditAddress={setIsEditAddress}
          isAddressChanged={isAddressChanged}
          setEditAddObj={setEditAddObj}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteUser(userRef);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("USER").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onPublishUser(userRef);
            setOpenPublishModal(false);
          } else {
            setOpenPublishModal(false);
          }
        }}
        displayText={publishMessage}
      />
    </div>
  );
};

export default UserSingleAction;
